import { CSSProperties, Theme } from "@remo-co/ui-core/src/types";
import { makeStyles } from "@remo-co/ui-core/src/utils/makeStyles";
import zIndexes from "zIndexes.module.scss";

export const useStyles = makeStyles<Theme>((theme) => ({
  eventPopper: {
    top: "-4px!important",
    zIndex: zIndexes.eventDirectoryMenuZIndex,
    userSelect: "none",
    width: "400px",
  },
  eventPopperMobile: {
    left: "5px!important",
    width: "100vw",
  },
  eventPopperMobilePresentation: {
    left: "5px!important",
    width: "100vw",
  },
  card: {
    padding: 0,
    border: 0,
    width: "400px",
    maxHeight: "50vh",
    overflowY: "auto",
  },
  cardMenuVisible: {
    borderTopLeftRadius: 0,
    borderTopRightRadius: 0,
  },
  cardPresentationMode: {
    backgroundColor: "#2C2F3C",
    border: "1px solid #333544",
  },
  cardMobile: {
    width: "100%",
    maxHeight: "calc(100vh - 160px)",
  },
  container: {
    padding: "8px",
    paddingTop: "15px",
  },
  goToRelatedEvents: {
    fontWeight: theme.typography.fontWeightMedium,
    color: theme.palette.events.textPrimary,
  } as CSSProperties,
  goToRelatedEventsPresentationMode: {
    color: theme.palette.white,
    opacity: 0.7,
  },
  cardItems: {
    padding: "12px 10px",
    borderRadius: 0,
    borderLeft: 0,
    borderRight: 0,
    borderBottom: 0,
    cursor: "pointer",

    "&:hover": {
      backgroundColor: theme.palette.gray.light,
    },
  },
  eventImage: {
    position: "relative",
    border: "1px solid #EAEAEA",
    borderRadius: "5px",
    width: "50px",
    minWidth: "50px",
    height: "36.67px",
    marginRight: "10px",
    objectFit: "cover",
  },
  dialog: {
    "& .MuiDialogContent-root": {
      width: 400,
      padding: "30px 20px 0px 20px",
    },
    "& .MuiDialogContentText-root": {
      marginLeft: "0!important",
      fontWeight: theme.typography.fontWeightMedium,
      fontSize: "16px",
    },
    "& .MuiFormControlLabel-root": {
      justifyContent: "flex-start",
      marginLeft: 10,
    },
    "& .MuiButtonBase-root": {
      height: 30,
    },
  },
}));
